import { useEffect } from "react";

const RoleHighlightBehaviour = () => {

  useEffect(() => {

    // Function to highlight selected role card
    function highlightSelected() {

      // Remove selection from all role cards
      document.querySelectorAll(".role-card").forEach(card => {
        card.classList.remove("selected");
      });

      // Add selection class to checked radio card
      document.querySelectorAll('input[name="role"]:checked').forEach(radio => {
        const card = radio.closest(".role-card");
        if (card) {
          card.classList.add("selected");
        }
      });
    }

    // Attach event listeners
    document.querySelectorAll('input[name="role"]').forEach(input => {
      input.addEventListener("change", highlightSelected);
    });

    // Initial highlight when component loads
    highlightSelected();

    // Cleanup listeners on unmount
    return () => {
      document.querySelectorAll('input[name="role"]').forEach(input => {
        input.removeEventListener("change", highlightSelected);
      });
    };

  }, []);

  return null;
};

export default RoleHighlightBehaviour;